export const list = {
  title: {
    name: '项目名称',
    key: 'title',
    check: true
  },
  project_members: {
    name: '创建者',
    key: 'project_members',
  },
  addtime: {
    name: '创建时间',
    key: 'addtime',
  },
  project_members_count: {
    name: '成员数量',
    key: 'project_members_count'
  }
};
